<script>
	import { nanoid } from "nanoid";

	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";

	export let name = null;
	export let selected = [];
	export let optionList = [];
	export let required = null;
	export let disabled = null;
	export let validator = null;
	export let validatorValue = null;
	export let validatorMessage = null;
	export let validatorTarget = null;
	export let labelProperty = "lookupName";
	export let valueProperty = "id";
	export let label;
	export let sublabel;
	export let useValue = true;
	// export let onchange = () => {};
</script>

{#if label}
	<!-- svelte-ignore a11y-label-has-associated-control -->
	<label>
		{label}

		{#if required || validator}
			<span class="required">*</span>
		{/if}

		{#if sublabel}
			<div class="sublabel">{sublabel}</div>
		{/if}
	</label>
{/if}
{#each optionList as option, i (option)}
	{@const id = nanoid(4)}
	<div>
		<FormColumn>
			<input
				type="checkbox"
				on:change
				bind:group={selected}
				value={useValue ? option[valueProperty] : option}
				{id}
				{name}
				data-validator={validator}
				data-validator-value={validatorValue}
				data-bouncer-message={validatorMessage}
				data-bouncer-target={validatorTarget}
				{required}
				{disabled} />
			<label for={id}>
				{@html option[labelProperty]}
			</label>
		</FormColumn>
	</div>
{/each}

<style>
	/* Base for label styling */
	[type="checkbox"]:not(:checked),
	[type="checkbox"]:checked {
		position: absolute;
		left: -9999px;
	}

	[type="checkbox"]:not(:checked) + label,
	[type="checkbox"]:checked + label {
		position: relative;
		width: 100%;
		min-height: 50px;
		border: 2px solid #ccc;
		background: #fff;
		border: solid 1px var(--color-border);
		border-radius: 1px;
		padding: var(--spacing-sm);
	}

	[type="checkbox"]:focus + label {
		text-decoration: underline;
	}

	[type="checkbox"]:checked + label {
		border-color: var(--color-primary);
		color: var(--color-primary) !important;
		box-shadow: inset 0 0 0 1px var(--color-primary) !important;
	}

	[type="checkbox"]:checked + label:after,
	[type="checkbox"]:not(:checked) + label:after {
		content: "";
		position: absolute;
		height: 18px;
		width: 18px;
		border-radius: 50%;
		background-color: var(--color-primary);
		z-index: 2;
		transition:
			top 0.4s,
			right 0.4s,
			opacity 0.4s;
	}

	[type="checkbox"]:checked + label:before,
	[type="checkbox"]:not(:checked) + label:before {
		content: "";
		position: absolute;
		transition: all 0.2s;
		border-bottom: 2px solid var(--color-white);
		border-right: 2px solid var(--color-white);
		transform: rotate(35deg);
		width: 6px;
		height: 10px;
		z-index: 3;
		transition:
			top 0.4s,
			right 0.4s,
			opacity 0.4s;
	}

	[type="checkbox"]:checked + label:after {
		top: -9px;
		right: -9px;
		opacity: 1;
	}

	[type="checkbox"]:checked + label:before {
		top: -6px;
		right: -3px;
		opacity: 1;
	}

	[type="checkbox"]:not(:checked) + label:after {
		top: 12px;
		right: 12px;
		opacity: 0;
	}

	[type="checkbox"]:not(:checked) + label:before {
		top: 15px;
		right: 18px;
		opacity: 0;
	}

	[type="checkbox"]:disabled + label {
		border: solid 1px var(--color-border);
		/* background-color: #e9ecef; */
		opacity: 1;
		color: #333 !important;
		box-shadow: none !important;
	}

	[type="checkbox"]:disabled:checked + label {
		background-color: var(--color-soft);
	}

	[type="checkbox"]:disabled:checked + label:after {
		background-color: var(--color-border);
	}
</style>
